// Model.js
// -----------------------
// @module Case
define("VintenCloud.Downloads.SS2Collection", ["Backbone", "Utils"], function (
    Backbone,
    Utils
) {
    "use strict";

    var original_fetch = Backbone.Collection.prototype.fetch;

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Collection.extend({
        //@property {String} urlRoot
        url: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/Downloads/SuiteScript2/AssetsDownload.Service.ss"
            ),
            true
        ),

        parse: function (response) {

            this.totalRecordsFound = response.totalRecordsFound;

            this.recordsPerPage = response.recordsPerPage;

            return response.records;

        }

    });
});
